// extracted by mini-css-extract-plugin
export default {"button":"appstore_button_button__uUYwY","button-content":"appstore_button_button-content__o7wO3","text":"appstore_button_text__Hxcey","logo":"appstore_button_logo__pR5u0"};